<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12">
                <v-text-field 
                    label="Name"
                    :rules="[isRequired]"
                    v-model="form.name"
                    outlined
                    dense
                    hide-details="auto"
                >
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from "./../../utils/validations"
export default {
    name: "SupplierGroupForm",
    props: {
        value: Object
    },
    data() {
        return {
            form : {
                name: ""
            }
        }
    },
    watch: {
        form: {
            deep: true,
            handler(val) {
                this.$emit("input", val);
            }
        }
    },
    methods: {
        isRequired,
        submit() {
            if(!this.$refs.form.validate()) return 
            this.$emit("submit", this.form)
        }
    },
    mounted() {
        this.form = {...this.form, ...this.value}
    }
}
</script>

<style>

</style>